export const GET_POLICY = 'v1/getPolicy'
export const GET_POLICY_PAYMENT = 'v1/getPolicyForPaymentValidation'
export const IS_BLOCK_POLICY = 'v1/is/blockPolicy'
export const REVERSE_FEED = 'v1/saveQuickPayReverseFeedData'
export const SAVE_PAYMENT_DETAILS = 'v1/savePaymentDetails'
export const GET_OTP = 'v1/getOTP'
export const Validate_Otp = 'v1/validateOTP'
export const generate_orderID = 'v1/generate/orderid'
export const PAYMENT_VERIFY = 'v1/payment/verify'
export const MIS_DUMP_LOGIN = 'auth/signin'
export const MIS_DUMP_DOWNLOAD = 'v1/misdata/getExcelExportAgent?'
export const NonAGent_MIS_DUMP_DOWNLOAD = 'v1/misdata/getExcelExportNonAgent?'
export const Policy_Excel_Download = 'v1/getPaymentDetailsExcel?uniqueIdentifier='
export const Policy_Excel_agent_Download = 'v1/agent/getPaymentDetailsExcel?uniqueIdentifier='
export const API_GENERATE_HASH="v1/generate-hash"
export const API_GET_PAYMENT_GATEWAY="v1/get-payment-gateway?uniqueIdentifier="
export const API_SAVE_PAYMENT_GATEWAY="v1/save-selected-payment-gateway"
export const API_PATH_PAYU_CREATE_ORDER="v1/generate/orderid-for-payu"
export const FIBE_INGESTION = '/v1/fibe/ingestion'
export const FIBE_ORDER_STATUS = '/v1/fibe/order'
export const FIBE_DISBURSEMENT = '/v1/fibe/disbursed'
